export function mapDisplayValues(offerList, display) {
    offerList.forEach((offer) => {

        if (display == "european") {
            if (offer.sportData) {
                offer.displayValues = {
                    result: offer.sportData.result,
                    teamOneName: offer.sportData.teamOneName,
                    teamTwoName: offer.sportData.teamTwoName,
                    teamOneGender: offer.sportData.teamOneGender,
                    teamTwoGender: offer.sportData.teamTwoGender,
                    teamOneId: offer.sportData.teamOneId,
                    teamTwoId: offer.sportData.teamTwoId,
                }
            }
            offer.displayValues.currentResult = offer.currentResult;

            return;
        };

        if (offer.sportData) {
            const currentResult = offer.currentResult ? JSON.parse(offer.currentResult) : null;
            const result = offer.sportData.result ? JSON.parse(offer.sportData.result) : null;

            updateResultModel(currentResult);
            updateResultModel(result);

            offer.displayValues = {
                currentResult: currentResult && JSON.stringify(currentResult),
                result: result && JSON.stringify(result),
                eventName: offer.sportData.eventName,
                teamOneName: offer.sportData.teamTwoName,
                teamTwoName: offer.sportData.teamOneName,
                teamOneGender: offer.sportData.teamTwoGender,
                teamTwoGender: offer.sportData.teamOneGender,
                teamOneId: offer.sportData.teamTwoId,
                teamTwoId: offer.sportData.teamOneId,
            }
        }
    })
}

function updateResultModel(result) {
    if (
        result == null ||
        result == "" ||
        (typeof result == "object" && Object.keys(result).length < 1)
    ) {
        return;
    }

    const switchFunction = (score) => {
        if (score.away && score.home) {
            const away = score.away;
            const home = score.home;

            score.home = away;
            score.away = home;
            return;
        }

        if (score.away) {
            score.home = score.away;
            delete score.away;
            return;
        }

        if (score.home) {
            score.away = score.home;
            delete score.home;
            return;
        }
    }

    if (result.scorePerPeriod && result.scorePerPeriod.length > 0) {
        result.scorePerPeriod.forEach(period => switchFunction(period));
    }

    if (result.currentGameScore) {
        switchFunction(result.currentGameScore);
    }

    if (result.tiebreakScore) {
        switchFunction(result.tiebreakScore);
    }

    if (result.currentScore) {
        switchFunction(result.currentScore);
    }

    if (result.serve) {
        if (result.serve == "away") {
            result.serve = "home";
        } else {
            result.serve = "away";
        }
    }

    const homeStats = result.homeTeamTotalStatistics;
    const awayStats = result.awayTeamTotalStatistics;

    if (homeStats && awayStats) {
        result.homeTeamTotalStatistics = awayStats;
        result.awayTeamTotalStatistics = homeStats;
    }
    else if (homeStats) {
        result.awayTeamTotalStatistics = homeStats;
        delete result.homeTeamTotalStatistics;
    }
    else if (awayStats) {
        result.homeTeamTotalStatistics = awayStats;
        delete result.awayTeamTotalStatistics;
    }
}

function constructSpecifiers(offer, defaultSpecifiers, lookupsStore) {
    const specs = {
        ...defaultSpecifiers,
    };

    if (
        lookupsStore.teams?.size > 0 &&
        offer.sportData.teamOneId != null &&
        offer.sportData.teamTwoId != null
    ) {
        specs.competitor1 =
            (lookupsStore.teams.get(offer.sportData.teamOneId)?.name) ||
            "";
        specs.competitor2 =
            (lookupsStore.teams.get(offer.sportData.teamTwoId)?.name) ||
            "";
    }

    if (
        offer.sportData.eventName
    ) {
        specs.event = offer.sportData.eventName || "";
    }

    if (
        lookupsStore.players?.size > 0 && offer.playerId
    ) {
        specs.player = constructPlayerName(
            lookupsStore.players.get(offer.playerId)
        );
    }

    return specs;
}

function constructPlayerName(player) {
    if (player == null) {
        return "";
    }

    if (player.lastName && player.firstName) {
        return `${player.lastName}, ${player.firstName}`;
    }

    return player.lastName || player.firstName || "";
}

export function createDisplayTip(offer, lookupsStore, nameProvider) {

    if (
        lookupsStore.players && offer.playerId
    ) {
        const player = lookupsStore.players.get(offer.playerId);

        if (player) {
            return constructPlayerName(player);
        }
    } else if (
        lookupsStore.teams && offer.teamId
    ) {
        const team = lookupsStore.teams.get(offer.teamId);

        if (team) {
            return team.name;
        } else {
            console.warn(`Team ${offer.teamId} not found in Teams lookup.`, {
                defaultTip: offer.defaultTip,
                teamId: offer.teamId,
            });
        }
    } else if (
        lookupsStore.bettingTypes?.size > 0 &&
        lookupsStore.bettingTypes.has(offer.bettingTypeId)
    ) {
        const btData =
            lookupsStore.bettingTypes.get(offer.bettingTypeId)

        if (btData?.tips?.length > 0) {
            const tip = btData.tips.find(
                (t) => t?.name === offer.bettingTypeTip
            );
            if (
                tip?.displayName
            ) {
                return nameProvider.getName(
                    tip.displayName,
                    constructSpecifiers(offer, offer.specifiers, lookupsStore)
                );
            }
        }
    }
    return nameProvider.getName(
        offer.bettingTypeTip,
        constructSpecifiers(offer, offer.specifiers, lookupsStore)
    );
}